/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2351
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.ConflictResolver = exports.GlobalCommentPlugin = exports.ProcedurePlugin = undefined
var r = require(/* 737 */"../../../737/index")
Object.defineProperty(exports, "ProcedurePlugin", {
  enumerable: true,
  get: function () {
    return r.ProcedurePlugin
  }
})
var i = require(/* 2352 */"./2352")
Object.defineProperty(exports, "GlobalCommentPlugin", {
  enumerable: true,
  get: function () {
    return i.GlobalCommentPlugin
  }
})
var o = require(/* 2353 */"./2353")
Object.defineProperty(exports, "ConflictResolver", {
  enumerable: true,
  get: function () {
    return o.ConflictResolver
  }
})
